import CONSTANTS from '../constants';
import AppService from "./appService";
import CacheService from './cacheService';
import axios from 'axios';

export default {
    getTrainers,
    getBusinessHours
};

async function getTrainers(skipAuth = false, businessName = null) {
    if (skipAuth) {
        return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.USER.TRAINERS}`, {
            headers: {
                'Business-Name': businessName,
                'Skip-Load-Resource': true
            }});
    }
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.USER.TRAINERS}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getBusinessHours(trainerId, date) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.USER.BUSINESS_HOURS(trainerId)}`, {
        params: {date: date},
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}